export function transformProducts(response) {
  const favouriteProducts = [];
  const notFavouriteProducts = [];

  response.list.forEach(categoryItem => {
    const { products } = categoryItem.category;
    products.forEach(product => {
      if (product.isDefaultFavorites || product.isFavorites) {
        // belongs to favourites
        favouriteProducts.push(product);
      } else if (!product.isDefaultFavorites && !product.isFavorites && product.canAddFavorites) {
        // belongs to not favourites
        notFavouriteProducts.push(product);
      }
    });
  });

  return { favouriteProducts, notFavouriteProducts };
}
